const mock2 = {
  title: `Título I <br /> Disposições preliminares`,
  article: '5',
  legislative: `
  <ul><li>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</li><li>Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</li></ul>`,
  jurisprudence: `
  <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>`,
  doctrinal: `
  <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
  `,
  text: `
  <strong>I - publicação - o oferecimento de obra literária, artística ou científica ao conhecimento do público, com o consentimento do autor, ou de qualquer outro titular de direito de autor, por qualquer forma ou processo;</strong>
  <br /><br />
  II - transmissão ou emissão - a difusão de sons ou de sons e imagens, por meio de ondas radioelétricas; sinais de satélite; fio, cabo ou outro condutor; meios óticos ou qualquer outro processo eletromagnético;
  <br /><br />
  III - retransmissão - a emissão simultânea da transmissão de uma empresa por outra;
  <br /><br />
  IV - distribuição - a colocação à disposição do público do original ou cópia de obras literárias artísticas ou científicas, interpretações ou execuções fixadas e fonogramas, mediante a venda, locação ou qualquer outra forma de transferência de propriedade ou posse;
  <br /><br />
  V - comunicação ao público - ato mediante o qual a obra é colocada ao alcance do público, por qualquer meio ou procedimento e que não consista na distribuição de exemplares;
  <br /><br />
  VI - reprodução - a cópia de um ou vários exemplares de uma obra literária, artística ou científica ou de um fonograma, de qualquer forma tangível, incluindo qualquer armazenamento permanente ou temporário por meios eletrônicos ou qualquer outro meio de fixação que venha ser desenvolvido;
  <br /><br />
  VII - contrafação - a reprodução não autorizada;
  <br /><br />
  <strong>VIII - obra:</strong>
  <br /><br />
  <strong>a) em co-autoria - quando é criada em comum, por dois ou mais autores;</strong>
  <br /><br />
  b) anônima - quando não se indica o nome do autor, por sua vontade ou por ser desconhecido;
  <br /><br />
  c) pseudônima - quando o autor se oculta sob nome suposto;
  <br /><br />
  d) inédita - a que não haja sido objeto de publicação;
  <br /><br />
  e) póstuma - a que se publique após a morte do autor;
  <br /><br />
  f) originária - a criação primígena;
  <br /><br />
  g) derivada - a que, constituindo criação intelectual nova, resulta da transformação de obra originária;
  <br /><br />
  h) coletiva - a criada por iniciativa, organização e responsabilidade de uma pessoa física ou jurídica, que a publica sob seu nome ou marca e que é constituída pela participação de diferentes autores, cujas contribuições se fundem numa criação autônoma;
  <br /><br />
  i) audiovisual - a que resulta da fixação de imagens com ou sem som, que tenha a finalidade de criar, por meio de sua reprodução, a impressão de movimento, independentemente dos processos de sua captação, do suporte usado inicial ou posteriormente para fixá-lo, bem como dos meios utilizados para sua veiculação;
  <br /><br />
  IX - fonograma - toda fixação de sons de uma execução ou interpretação ou de outros sons, ou de uma representação de sons que não seja uma fixação incluída em uma obra audiovisual;
  <br /><br />
  X - editor - a pessoa física ou jurídica à qual se atribui o direito exclusivo de reprodução da obra e o dever de divulgá-la, nos limites previstos no contrato de edição;
  <br /><br />
  XI - produtor - a pessoa física ou jurídica que toma a iniciativa e tem a responsabilidade econômica da primeira fixação do fonograma ou da obra audiovisual, qualquer que seja a natureza do suporte utilizado;
  <br /><br />
  XII - radiodifusão - a transmissão sem fio, inclusive por satélites, de sons ou imagens e sons ou das representações desses, para recepção ao público e a transmissão de sinais codificados, quando os meios de decodificação sejam oferecidos ao público pelo organismo de radiodifusão ou com seu consentimento;
  <br /><br />
  XIII - artistas intérpretes ou executantes - todos os atores, cantores, músicos, bailarinos ou outras pessoas que representem um papel, cantem, recitem, declamem, interpretem ou executem em qualquer forma obras literárias ou artísticas ou expressões do folclore.
  <br /><br />
  XIV - titular originário - o autor de obra intelectual, o intérprete, o executante, o produtor fonográfico e as empresas de radiodifusão. (Incluído pela Lei nº 12.853, de 2013)
  `,
  comments: [{
    id: 1,
    name: 'Nome da Pessoa',
    institution: 'Nome da instituição',
    message: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
    date: '09/12/2022'
  }, {
    id: 2,
    name: 'Nome da Pessoa',
    institution: 'Nome da instituição',
    message: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
    date: '09/12/2022'
  }, {
    id: 3,
    name: 'Nome da Pessoa',
    institution: 'Nome da instituição',
    message: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
    date: '09/12/2022'
  }]
}

const mock = {
  title: '',
  article: '',
  legislative: '',
  jurisprudence: '',
  doctrinal: '',
  text: '',
  comments: []
}

export default mock